import { render, staticRenderFns } from "./HomeNavigationControlCta.vue?vue&type=template&id=ddd25a34&scoped=true&"
import script from "./HomeNavigationControlCta.vue?vue&type=script&lang=js&"
export * from "./HomeNavigationControlCta.vue?vue&type=script&lang=js&"
import style0 from "./HomeNavigationControlCta.vue?vue&type=style&index=0&id=ddd25a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd25a34",
  null
  
)

export default component.exports